module.exports = __webpack_public_path__ + "static/media/tou-people.b4658b0e.png";